var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeasurementIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1948.5,1183c0-13-0.1-26.3-0.1-39.9c0.4,2.8,0.9,5.5,1.3,8.2C1949.2,1161.9,1948.9,1172.5,1948.5,1183z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812,1187C406,781,400,774,400,735c0-38,7-47,148-188c140-140,149-147,187-147c39,0,47,7,453,413s412,413,412,452 c0,38-7,47-148,188c-140,140-149,147-187,147C1226,1600,1218,1593,812,1187z M1133,868L735,470L603,602L470,735l64,64l65,65l45-42 c50-46,80-53,96-22c9,17,4,27-36,71l-48,50l52,52l52,51l44-43c31-31,50-42,67-39c42,6,37,44-12,94l-43,44l52,52l52,52l44-43 c50-49,88-54,94-12c3,17-8,36-39,67l-43,44l51,52l52,52l50-48c44-40,54-45,71-36c31,16,24,46-22,96l-41,45l64,65l64,64l132-132 l133-133L1133,868z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurementIcon);
export default __webpack_public_path__ + "static/media/measurement-icon.7847734b7e3659f209e6e269ea2a32c1.svg";
export { ForwardRef as ReactComponent };